import { useMutation } from "@apollo/client";

import { SUBSCRIPTION_CREATE } from "MVVM/GraphQL/mutations/subscriptionCreate";

export const AdRemovalCTAViewModel = () => {
  const [subscriptionCreate, { data, loading, error }] =
    useMutation(SUBSCRIPTION_CREATE);

  return {
    subscriptionCreate,
    data,
    loading,
    error,
  };
};
